import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IParentSubjectResponse,
  IParentSyllabusResponse,
} from '../../interface/parentSubject.interface';
import { IErrorResponse } from '../../interface/main.interface';
import { parentSubjectService } from '../../services/parentSubject';
import { normalizeAxiosError } from '../../utility/axiosErrorHandler';

export const fetchParentSubjects = createAsyncThunk<
  IParentSubjectResponse,
  { studentId: string },
  { rejectValue: IErrorResponse }
>('parentSubject/fetch-subjects', async ({ studentId }, { rejectWithValue }) => {
  try {
    const response = await parentSubjectService.fetchParentSubjects(studentId);
    return response.data;
  } catch (err) {
    return rejectWithValue(normalizeAxiosError(err, 'Failed to fetch subjects.'));
  }
});

export const fetchParentSyllabus = createAsyncThunk<
  IParentSyllabusResponse,
  { studentId: string; subjectAssignId: string },
  { rejectValue: IErrorResponse }
>('parentSubject/fetch-syllabus', async ({ studentId, subjectAssignId }, { rejectWithValue }) => {
  try {
    const response = await parentSubjectService.fetchParentSyllabus(studentId, subjectAssignId);
    return response.data;
  } catch (err) {
    return rejectWithValue(normalizeAxiosError(err, 'Failed to fetch the syllabus.'));
  }
});

export const parentSubjectActions = {
  fetchParentSubjects,
  fetchParentSyllabus,
};
